<div class="fullscreen padd dark light animated fadeIn">

  <div class="card text-white bg-dark" style="max-width: 25rem;">
    <div class="card-header">**NOMINAS**</div>
    <div class="card-body">
      <h5 class="card-title">Importador</h5>
      <p class="card-text">Arrastre o seleccione la carpeta del periodo para ser importado a la base de datos.</p>

      <!-- File input for the file-upload plugin, with special ng2-file-upload directive called ng2FileSelect -->
      <input type="file" name="afip" ng2FileSelect [uploader]="uploader" />
      <!-- button to trigger the file upload when submitted -->
      <button type="button" class="btn btn-danger" (click)="uploader.uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">
        Importar
      </button>
    </div>
  </div>

</div>
